import React, { Component } from 'react';
import { withRouter } from 'components/Routing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { Link } from 'components/Routing';

import PropTypes from 'prop-types';

class BackButton extends Component {
    constructor(props) {
        super(props);        
        this.state = {
            showBackButton: this.props.showBackButton,
        }
    }
    
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.showBackButton !== prevState.showBackButton) {
            return {
                showBackButton : nextProps.showBackButton
            };
        }

        return null;
    }

    render() {
        return (
            <React.Fragment>
                {this.state.showBackButton ? 
                    <React.Fragment>
                        <span tabIndex="0" aria-label="Back" role="button" onClick={()=>this.props.router.navigate(-1)} className="header__btn-back pull-left">
                            <FontAwesomeIcon icon={faArrowLeft} size={"1x"} className="mt-2"/>
                        </span>
                        <Link tabIndex="0"  aria-label="Home" role="button" to="/" className="header__btn-home pull-left">
                            <FontAwesomeIcon icon={faHome} size={"1x"} className="mt-2"/>
                        </Link>
                    </React.Fragment>
                    : 
                    null
                }
            </React.Fragment>
        )
    }
}

BackButton.defaultProps = {
    showBackButton: true,
}

BackButton.propTypes = {
    showBackButton: PropTypes.bool,
}

export default withRouter(BackButton);